/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */

import { setIncludeNocacheHeader } from '@/components/commons/apollo.js';
import { createApp } from '../components/app.js';

setIncludeNocacheHeader(!!window.__APOLLO_NOCACHE__);

const { app, router, store } = createApp({
  ssr: false,
});

router.onReady(() => {
  // replacing store from server
  if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__);
  }

  app.$mount('#app');
});
